import React from 'react'
import { observer } from 'mobx-react-lite'
import { type ITextFieldProps, TextField } from 'shared/ui/TextField'

import { DatePicker, Dropdown, DropdownContent, type IDropdownProps } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'

import { DayjsFormats } from 'shared/lib'
import styles from './styles.module.scss'
import '../react-datepicker.css'

export type IDatePickerTextFieldProps = {
  date?: Date | null
  handleDate?: (date: Date | null) => void
  textFieldProps: ITextFieldProps
  dropdownProps: Omit<IDropdownProps, 'customComponent' | 'triggerComponent'>
  withUiOffset?: boolean
}

export const DatetimePickerTextField: React.FC<IDatePickerTextFieldProps> = observer(
  ({ date, handleDate, textFieldProps, dropdownProps, withUiOffset }) => {
    const dateWithOffset = date
      ? uiStore.dayjs(date).add(uiStore.offsetMinute, 'minutes').toDate()
      : null

    const handleDateWithOffsetMinutes = (date: Date | null) => {
      handleDate?.(date ? uiStore.dayjs(date).add(-uiStore.offsetMinute, 'minutes').toDate() : null)
    }

    return (
      <Dropdown
        width={304}
        placement={'bottom-end'}
        customComponent={(onCloseMenu, dropdownId) => (
          <DropdownContent className={styles.wrapDropdown}>
            <DatePicker
              type={'singleExpanded'}
              date={withUiOffset ? dateWithOffset : date}
              handleDate={withUiOffset ? handleDateWithOffsetMinutes : handleDate}
              parentsDropdownId={[dropdownId]}
              calendarClassName={styles.calendarClassName}
              wrapInputsClassName={styles.wrapInputsClassName}
              placeholder={'Select'}
              timePickerPopperProps={{
                disablePortal: true,
              }}
            />
          </DropdownContent>
        )}
        triggerComponent={() => (
          <TextField
            value={date ? uiStore.dayjs(date).format(DayjsFormats.fullWithAtDash2) : ''}
            {...textFieldProps}
          />
        )}
        {...dropdownProps}
      />
    )
  }
)
